import { UserType } from '../../entities/tenant/user.type';
import { PortalClientSecurityRight } from '../modules/portal.clients.security.module';
import { AppSecurityRight } from '../modules/app.security';
import { SecurityRole, SecurityRoleType } from '../security.role';


export class ClientUser implements SecurityRole {

    _id = '23dd80ae-6bd7-4992-96e2-ed0e764ebeee';
    system = true;
    hidden = false;
    type = UserType.Client;
    name = SecurityRoleType.ClientUser;
    description = 'Access to Client Portal';
    rights = [
        AppSecurityRight.LoginClient,
        PortalClientSecurityRight.CanAccessJobs,
        //PortalClientSecurityRight.ManageActivity,
        PortalClientSecurityRight.ViewInvoice,
        PortalClientSecurityRight.RequestNewJob,
        PortalClientSecurityRight.RequestNewQuote
    ];

}
